import React from "react"
import { useFormik } from "formik"
import { FormGroup, Input } from "reactstrap"
import * as Yup from "yup"
import { Button } from "components/Button"

import { FIELDS_NAME, initialValues, validationSchema } from "./FormConfig"

const NewNoteForm = ({ onCancel, onSubmit, isLoading }) => {
   const formik = useFormik({
      initialValues,
      validationSchema,
      onSubmit: async values => {
         await onSubmit(values)
         formik.resetForm()
         onCancel()
      },
   })

   return (
      <form onSubmit={formik.handleSubmit}>
         <label className="form-label mb-1">Note</label>
         {/* <FormGroup className=""> */}
         <Input
            type="textarea"
            name={FIELDS_NAME.TEXT_AREA_VALUE}
            placeholder="Add a note..."
            value={formik.values.textAreaValue}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            invalid={
               formik.touched.textAreaValue && !!formik.errors.textAreaValue
            }
            style={{ resize: "none", height: "80px" }}
         />
         {formik.touched.textAreaValue && formik.errors.textAreaValue && (
            <div className="form-input-error text-danger">
               {formik.errors.textAreaValue}
            </div>
         )}
         {/* </FormGroup> */}
         <div className="text-end d-flex justify-content-end gap-1">
            <Button
               type="submit"
               color="primary"
               isLoading={isLoading}
               title="Add Note"
               className="mt-2 note-btn-primary"
            />

            <Button
               type="button"
               color="danger"
               className="mt-2 note-btn-secondary"
               onClick={onCancel}
               disabled={isLoading}
               title="Cancel"
            />
         </div>
      </form>
   )
}

export default NewNoteForm
